/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { JobDefinition } from '../model/jobDefinition';
import { JobDefinitionCreateRequest } from '../model/jobDefinitionCreateRequest';
import { JobDefinitionKeys } from '../model/jobDefinitionKeys';
import { JobDefinitionUpdateRequest } from '../model/jobDefinitionUpdateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class JobDefinitionService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createJobDefinition
     * Creates a new job definition. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param jobDefinitionCreateRequest the information needed to create the job definition.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobDefinitionCreateJobDefinition(jobDefinitionCreateRequest: JobDefinitionCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<JobDefinition>;
    public jobDefinitionCreateJobDefinition(jobDefinitionCreateRequest: JobDefinitionCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JobDefinition>>;
    public jobDefinitionCreateJobDefinition(jobDefinitionCreateRequest: JobDefinitionCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JobDefinition>>;
    public jobDefinitionCreateJobDefinition(jobDefinitionCreateRequest: JobDefinitionCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (jobDefinitionCreateRequest === null || jobDefinitionCreateRequest === undefined) {
            throw new Error('Required parameter jobDefinitionCreateRequest was null or undefined when calling jobDefinitionCreateJobDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<JobDefinition>(`${this.configuration.basePath}/jobDefinitions`,
            jobDefinitionCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getJobDefinition
     * Gets an existing job definition. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the job definition.
     * @param jobName the job name of the job definition.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobDefinitionGetJobDefinition(namespace: string, jobName: string, observe?: 'body', reportProgress?: boolean): Observable<JobDefinition>;
    public jobDefinitionGetJobDefinition(namespace: string, jobName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JobDefinition>>;
    public jobDefinitionGetJobDefinition(namespace: string, jobName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JobDefinition>>;
    public jobDefinitionGetJobDefinition(namespace: string, jobName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling jobDefinitionGetJobDefinition.');
        }
        if (jobName === null || jobName === undefined) {
            throw new Error('Required parameter jobName was null or undefined when calling jobDefinitionGetJobDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<JobDefinition>(`${this.configuration.basePath}/jobDefinitions/namespaces/${encodeURIComponent(String(namespace))}/jobNames/${encodeURIComponent(String(jobName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getJobDefinitionKeys
     * Gets a list of keys for all job definitions defined in the system for the specified namespace. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the job definition
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobDefinitionGetJobDefinitionKeys(namespace: string, observe?: 'body', reportProgress?: boolean): Observable<JobDefinitionKeys>;
    public jobDefinitionGetJobDefinitionKeys(namespace: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JobDefinitionKeys>>;
    public jobDefinitionGetJobDefinitionKeys(namespace: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JobDefinitionKeys>>;
    public jobDefinitionGetJobDefinitionKeys(namespace: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling jobDefinitionGetJobDefinitionKeys.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<JobDefinitionKeys>(`${this.configuration.basePath}/jobDefinitions/namespaces/${encodeURIComponent(String(namespace))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateJobDefinition
     * Updates an existing job definition. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace of the job definition.
     * @param jobName the job name of the job definition.
     * @param jobDefinitionUpdateRequest the information needed to update the job definition.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public jobDefinitionUpdateJobDefinition(namespace: string, jobName: string, jobDefinitionUpdateRequest: JobDefinitionUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<JobDefinition>;
    public jobDefinitionUpdateJobDefinition(namespace: string, jobName: string, jobDefinitionUpdateRequest: JobDefinitionUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JobDefinition>>;
    public jobDefinitionUpdateJobDefinition(namespace: string, jobName: string, jobDefinitionUpdateRequest: JobDefinitionUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JobDefinition>>;
    public jobDefinitionUpdateJobDefinition(namespace: string, jobName: string, jobDefinitionUpdateRequest: JobDefinitionUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling jobDefinitionUpdateJobDefinition.');
        }
        if (jobName === null || jobName === undefined) {
            throw new Error('Required parameter jobName was null or undefined when calling jobDefinitionUpdateJobDefinition.');
        }
        if (jobDefinitionUpdateRequest === null || jobDefinitionUpdateRequest === undefined) {
            throw new Error('Required parameter jobDefinitionUpdateRequest was null or undefined when calling jobDefinitionUpdateJobDefinition.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<JobDefinition>(`${this.configuration.basePath}/jobDefinitions/namespaces/${encodeURIComponent(String(namespace))}/jobNames/${encodeURIComponent(String(jobName))}`,
            jobDefinitionUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
